"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Avatar_1 = __importDefault(require("components/shared/Avatar"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const HelperUtils_1 = require("src/utils/HelperUtils");
require("./SingleUserList.scss");
function SingleUserList({ user, onClick }) {
    return (react_1.default.createElement("div", { "data-cy": `user-${user.id}`, className: "single-user-list", onClick: () => onClick(user) },
        react_1.default.createElement(Avatar_1.default, { src: user.profilePicture, name: user.name, wrapperClassName: "mx-[16px] my-[4px]", className: "profile-picture", size: 32 }),
        react_1.default.createElement("div", { className: "flex flex-col w-full" },
            react_1.default.createElement(TruncateParagraph_1.default, { position: "bottom", useMaxWidth: true, className: "typography-h400 text-n-900" }, user.name),
            react_1.default.createElement(TruncateParagraph_1.default, { position: "bottom", useMaxWidth: true, className: "typography-h100 text-n-800" }, (0, HelperUtils_1.getExtraInformation)(user === null || user === void 0 ? void 0 : user.title, user === null || user === void 0 ? void 0 : user.subtitle)))));
}
exports.default = SingleUserList;
